import { useContext, useState } from 'react';
import handleChange from '../../../utils/handleChange';
import './supLogin.css';
import emailValid from '../../../utils/emailValid';
import { supLoginFunAPI, supOTPFunAPI } from '../../../api/supLoginAPI';
import errorHandle from '../../../utils/errorHandle';
import ReactLoading from 'react-loading';
import { toast } from 'react-toastify';
import { SupAuthContext } from '../../../context/SupAuthContext';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import OTPInput from '../../otpinput/otpinput';
import TrvToLogo from '../../../assets/images/trvto-logo.png';
import { ReactComponent as TravelImg } from '../../../assets/images/trvto_travel.svg';
import { ReactComponent as Announcement } from '../../../assets/images/trvto_announcement.svg';
import { ReactComponent as Phone } from '../../../assets/icons/trvto_phone.svg';
import { ReactComponent as Email } from '../../../assets/icons/trvto_email.svg';

function SupLogin({ setLogButton, setLoginSec }) {
    const navigate = useNavigate();
    const [userDetails, setUserDetails] = useState({
        emailId: '',
        otp: ''
    });
    const [emailError, setEmailError] = useState('');
    const [otpError, setOtpError] = useState('');
    const [loading, setLoading] = useState(false);
    const [response, setResponse] = useState('400');
    const { mode } = useParams();

    const { isSupAuthenticated, SupLoginFun } = useContext(SupAuthContext);

    async function getSupOTP() {
        if (!emailValid(userDetails.emailId)) {
            setEmailError('Please enter a valid email address');
            return;
        }
        setEmailError('');
        setLoading(true);
        try {
            const res = await supOTPFunAPI(userDetails);
            //End Loadin
            setLoading(false);
            //Set response to 200 telling OTP is sent
            setResponse('200');
            //Notifaction of OTP sent
            toast.success('OTP sent to your email');
        } catch (error) {
            console.log(error);
            errorHandle(error);
            //End loading animation
            setLoading(false);
        }
    }

    //check for valid email id and
    //send supLogin information to backend for verification
    async function handleLogin() {
        if (userDetails.otp.length <= 5) {
            setOtpError('Please enter the complete OTP');
            return;
        }
        setOtpError('');
        //Start loading animation
        setLoading(true);

        try {
            const supLoginData = await supLoginFunAPI(userDetails);
            //Show notifation of Login success
            toast.success('Login Successful');
            //End loading animation
            setLoading(false);
            SupLoginFun(supLoginData.data);
            navigate(`/support/${mode}/tickets`);
        } catch (error) {
            errorHandle(error);
            //End loading animation
            setLoading(false);
        }
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            response !== '200' ? getSupOTP() : handleLogin();
        }
    };

    // if (isSupAuthenticated) {
    //     // return <Navigate from="support/login" to="/support/assistance" />;
    //     // return <Navigate to="/org/dashboard" />;
    // }

    return (
        <div>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
            <div className='supLogin'>
                <div>
                    <div className='supLoginLogoDiv'>
                        <img src={TrvToLogo} alt='trvto_logo' className='supLogoImg' loading='lazy' decoding='async' />
                    </div>
                    <div className='supLoginDiv'>
                        <Announcement />
                        <h1 className='supLoginH1'>Support Login</h1>

                        <div className='supLoginInputDiv'>
                            <input
                                placeholder='Support Email'
                                name='emailId'
                                onChange={(e) => handleChange(e, setUserDetails)}
                                onKeyDown={handleKeyDown}
                                value={userDetails.emailId}
                                type='email'
                                className='supLoginInput'
                            />
                            {emailError && <span className='supLoginError'>{emailError}</span>}
                            {response === '200' && (
                                <div className='supInputDiv'>
                                    <p>Check your email for OTP</p>
                                    <label>OTP</label>
                                    <OTPInput
                                        length={6}
                                        setUserData={setUserDetails}
                                        keyName={'otp'}
                                        handleKeyDown={handleKeyDown}
                                    />
                                </div>
                            )}
                            {response === '200' && otpError && <span className='supLoginError'>{otpError}</span>}
                        </div>
                        <button
                            type='button'
                            onClick={() => (response !== '200' ? getSupOTP() : handleLogin())}
                            className='supLoginBtn'
                        >
                            Login
                        </button>
                    </div>
                </div>
                <div className='supLoginInfoDiv'>
                    <TravelImg />
                    <h2>Want to work with us? Contact Our team.</h2>
                    <div className='contact-details sup-login supContInfDiv'>
                        <div className='details-item'>
                            <div className='icon-con'>
                                <Phone />
                            </div>
                            <a href='tel:8088788874'>8088788874</a>
                        </div>
                        <div className='details-item'>
                            <div className='icon-con'>
                                <Email />
                            </div>{' '}
                            <a href='mailto:info@trvto.com'>info@trvto.com</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SupLogin;
